"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[7671],{

/***/ 57671:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ OnboardingModal)
});

// EXTERNAL MODULE: ./pages/questions/components/onboarding_modal/images/avatar.png
var avatar = __webpack_require__(20971);
// EXTERNAL MODULE: ./pages/questions/components/onboarding_modal/index.erb
var onboarding_modal = __webpack_require__(46137);
// EXTERNAL MODULE: ./pages/questions/components/onboarding_modal/index.rb
var components_onboarding_modal = __webpack_require__(45471);
// EXTERNAL MODULE: ./pages/questions/components/onboarding_modal/question_challange.erb
var question_challange = __webpack_require__(29998);
// EXTERNAL MODULE: ./pages/questions/components/onboarding_modal/question_tip.erb
var question_tip = __webpack_require__(8830);
// EXTERNAL MODULE: ./pages/questions/components/onboarding_modal/welcome.erb
var welcome = __webpack_require__(40707);
// EXTERNAL MODULE: ./utils/ajax_component_loader/index.js
var ajax_component_loader = __webpack_require__(62346);
// EXTERNAL MODULE: ./pages/questions/components/challenge_feedback/images/rocket_up.png
var rocket_up = __webpack_require__(21636);
// EXTERNAL MODULE: ./pages/questions/components/challenge_feedback/images/studing_boy.png
var studing_boy = __webpack_require__(62515);
// EXTERNAL MODULE: ./pages/questions/components/challenge_feedback/index.erb
var challenge_feedback = __webpack_require__(48933);
// EXTERNAL MODULE: ./pages/questions/components/challenge_feedback/index.module.scss
var index_module = __webpack_require__(77399);
// EXTERNAL MODULE: ./pages/questions/components/challenge_feedback/index.rb
var components_challenge_feedback = __webpack_require__(96983);
;// CONCATENATED MODULE: ./pages/questions/components/challenge_feedback/index.js





class ChallengeFeedback {
    constructor(){
        const $dismissButton = window.jQuery('.js-onboarding-dismiss');
        const $container = window.jQuery('.js-onboarding-container');
        if ($dismissButton.length) {
            $dismissButton.on('click', ()=>$container.hide());
        }
    }
}


// EXTERNAL MODULE: ./utils/cookie_manager/index.js
var cookie_manager = __webpack_require__(88526);
;// CONCATENATED MODULE: ./pages/questions/components/onboarding_modal/index.js









const WELCOME_PHASE = '0';
const FILTER_PHASE = '1';
const COMMENTARY_PHASE = '2';
const ONBOARDING_OFF = 'false';
class OnboardingModal {
    get onboardingPhase() {
        return cookie_manager/* default.getCookie */.Z.getCookie(this.cookieName);
    }
    get currentElement() {
        const phasesElements = {
            [WELCOME_PHASE]: this.$welcomeElement,
            [FILTER_PHASE]: this.$filterTipElement,
            [COMMENTARY_PHASE]: this.$commentaryTipElement
        };
        return phasesElements[this.onboardingPhase];
    }
    setOnboardingPhase(val) {
        cookie_manager/* default.setExpirationCookie */.Z.setExpirationCookie(this.cookieName, val, 1);
    }
    startOnboarding() {
        this.setOnboardingPhase(FILTER_PHASE);
        this.loadPhase();
    }
    dismissOnboarding() {
        this.$phasesElements.hide();
        this.pauseIframe();
        if (this.onboardingPhase === WELCOME_PHASE || this.onboardingPhase === COMMENTARY_PHASE) {
            this.setOnboardingPhase(false);
        }
    }
    loadPhase() {
        this.$phasesElements.hide();
        this.$minimizedAvatar.hide();
        this.pauseIframe();
        this.$minimizedAvatar.tooltip('hide');
        this.currentElement && this.currentElement.show();
    }
    pauseIframe() {
        if (this.$iframeElement.length) {
            const currentVideo = this.$iframeElement[0].src;
            this.$iframeElement[0].src = '';
            this.$iframeElement[0].src = currentVideo;
        }
    }
    handleQuestionChallengeFeedback() {
        this.dismissOnboarding();
        this.addQuestionToCookies();
        this.setOnboardingPhase(false);
        ajax_component_loader/* default.load */.Z.load({
            component: 'questions/challenge_feedback',
            type: 'page_component',
            data: {
                answer: this.userAnswerValue,
                question: this.currentQuestion
            }
        }).then((html)=>{
            window.jQuery('body').append(html);
            new ChallengeFeedback();
        });
    }
    addQuestionToCookies() {
        const currentValue = cookie_manager/* default.getCookie */.Z.getCookie('question_challange_answered');
        const parsedArray = currentValue ? JSON.parse(currentValue) : [];
        const questionsUpdated = parsedArray ? [
            ...parsedArray,
            this.currentQuestion
        ] : [
            this.currentQuestion
        ];
        cookie_manager/* default.setPersistentCookie */.Z.setPersistentCookie('question_challange_answered', JSON.stringify(questionsUpdated));
    }
    minimizeWindow() {
        this.$phasesElements.hide();
        this.$minimizedAvatar.show();
    }
    show() {
        if (this.onboardingPhase === ONBOARDING_OFF) {
            return;
        }
        this.$container.show();
        if (this.onboardingPhase === WELCOME_PHASE) {
            return this.loadPhase();
        }
        this.$minimizedAvatar.show();
    }
    bind() {
        var _this_$answerChallengeBtn;
        this.$dismissButton.on('click', ()=>this.dismissOnboarding());
        this.$agreementButton.on('click', ()=>this.startOnboarding());
        this.$minimizedAvatar.on('click', ()=>this.loadPhase());
        this.$minimizeBtn.on('click', ()=>this.minimizeWindow());
        (_this_$answerChallengeBtn = this.$answerChallengeBtn) == null ? void 0 : _this_$answerChallengeBtn.on('click', (e)=>{
            this.$answerChallengeBtn.removeClass('active');
            window.jQuery(e.target).addClass('active');
            this.userAnswerValue = window.jQuery(e.target).attr('value');
        });
        this.$confirmAnswerBtn.on('click', ()=>{
            this.setOnboardingPhase(COMMENTARY_PHASE);
            this.loadPhase();
        });
        this.$changeAnswerBtn.on('click', ()=>{
            this.setOnboardingPhase(FILTER_PHASE);
            this.loadPhase();
        });
        this.$endQuestionChallenge.on('click', ()=>this.handleQuestionChallengeFeedback());
        this.setOnboardingPhase(0);
        this.loadPhase();
    }
    constructor(){
        this.cookieName = 'question_challange_phase';
        this.$container = window.jQuery('.js-onboarding-container');
        this.$minimizedAvatar = window.jQuery('.js-onboarding-minimized-avatar', this.$container);
        this.$phasesElements = window.jQuery('.js-onboarding-phases', this.$container);
        this.$welcomeElement = window.jQuery('.js-welcome-phase', this.$container);
        this.$filterTipElement = window.jQuery('.js-filter-tip-phase', this.$container);
        this.$commentaryTipElement = window.jQuery('.js-commentary-tip-phase', this.$container);
        this.$iframeElement = window.jQuery('.question-challange__video-tip', this.$container);
        this.$answerChallengeBtn = window.jQuery('.js-question-challange-option', this.$container);
        this.$confirmAnswerBtn = window.jQuery('.js-question-challange-answer', this.$container);
        this.$changeAnswerBtn = window.jQuery('.js-question-challange-reanswer', this.$container);
        this.$endQuestionChallenge = window.jQuery('.js-question-challange-end', this.$container);
        this.currentQuestion = this.$container.data('question-id');
        this.$dismissButton = window.jQuery('.js-onboarding-dismiss', this.$container);
        this.$agreementButton = window.jQuery('.js-onboarding-agreement', this.$container);
        this.$minimizeBtn = window.jQuery('.js-minimize-onboarding', this.$container);
        this.bind();
        this.show();
    }
}



/***/ })

}]);